var map = {
	"./BC.png": "dae2",
	"./BabyComposerLogo.png": "23f5",
	"./CC.png": "abe8",
	"./CorneliusComposerLogo.png": "c711",
	"./FM.png": "7153",
	"./FMBundle.webp": "50b1",
	"./FluteMasterLogo.png": "c6b7",
	"./HC.png": "1f70",
	"./HCBundle.webp": "682d",
	"./HM.png": "8d71",
	"./HarmonyCityLogo.png": "8e62",
	"./HelloMusicLogo.png": "ca13",
	"./MacAppStore.png": "3420",
	"./MicrosoftStore.png": "eaa3",
	"./Poppins/OFL.txt": "9bf21",
	"./Poppins/Poppins-Black.ttf": "bf00",
	"./Poppins/Poppins-BlackItalic.ttf": "7dcb",
	"./Poppins/Poppins-Bold.ttf": "48a1",
	"./Poppins/Poppins-BoldItalic.ttf": "b2bd",
	"./Poppins/Poppins-ExtraBold.ttf": "8e3a",
	"./Poppins/Poppins-ExtraBoldItalic.ttf": "6ed7",
	"./Poppins/Poppins-ExtraLight.ttf": "1ae6",
	"./Poppins/Poppins-ExtraLightItalic.ttf": "f701",
	"./Poppins/Poppins-Italic.ttf": "d0b6",
	"./Poppins/Poppins-Light.ttf": "c157",
	"./Poppins/Poppins-LightItalic.ttf": "83e8",
	"./Poppins/Poppins-Medium.ttf": "d536",
	"./Poppins/Poppins-MediumItalic.ttf": "17f3",
	"./Poppins/Poppins-Regular.ttf": "48d3",
	"./Poppins/Poppins-SemiBold.ttf": "8184",
	"./Poppins/Poppins-SemiBoldItalic.ttf": "f441",
	"./Poppins/Poppins-Thin.ttf": "76af",
	"./Poppins/Poppins-ThinItalic.ttf": "7927",
	"./RV.png": "b71b",
	"./RVBundle.webp": "94dc",
	"./RhythmicVillageLogo.png": "58bd",
	"./appKey.webp": "e06d",
	"./babyComposer.png": "90f1",
	"./bundles-Custom.jpg": "1972",
	"./bundles-Custom.png": "a48a",
	"./corneliusComposer.png": "38db",
	"./cropped-favicons_classplash-favicon-32x32.png": "b4a9",
	"./cropped-logo-01-min.png": "5dc2",
	"./draw-check-mark.svg": "c9ee",
	"./env": "f517",
	"./env.js": "f517",
	"./fluteMaster.png": "9585",
	"./fm_end_signup.png": "5409",
	"./fm_end_signup.webp": "77e7",
	"./fm_rv_selectLanguage.png": "c178",
	"./galaxy.webp": "7954",
	"./harmonyCity.png": "2da5",
	"./hc_end_signup.png": "b2c4",
	"./hc_end_signup.webp": "30a7",
	"./hc_login_1.png": "6bba",
	"./hc_login_2.png": "8508",
	"./hc_selectLanguage.png": "ab4d",
	"./helloMusic.png": "eb2b",
	"./index.html": "cb67",
	"./licenseSelect.png": "4aa6",
	"./planet.webp": "7fd3",
	"./planetGalaxy.webp": "4bdf",
	"./planetGalaxyIcon.webp": "fb8e",
	"./rhythmicVillage.png": "54eb",
	"./rv_end_signup.png": "fc17",
	"./rv_end_signup.webp": "ef70",
	"./storelinkFluteMaster.png": "26d2",
	"./storelinkHarmonyCity.png": "de95",
	"./storelinkRhythmicVillage.png": "5e0c",
	"./theMagicFlute/AcademyExteriorSunset.webp": "8ac9",
	"./theMagicFlute/NightCastleStableShot.jpg": "e5be",
	"./theMagicFlute/NightCastleStableShot.webp": "b49c",
	"./theMagicFlute/appstore-icon.png": "c42a",
	"./theMagicFlute/google-play-icon.png": "3451",
	"./theMagicFlute/library-night.jpg": "3edf",
	"./theMagicFlute/library-night.webp": "8e45",
	"./theMagicFlute/nightcastle-throne.jpg": "e2bb",
	"./theMagicFlute/nightcastle-throne.webp": "5561",
	"./theMagicFlute/tmf-castle.png": "0d04",
	"./theMagicFlute/tmf-castle.webp": "3481",
	"./theMagicFlute/tmf-eye-icon.png": "9bed",
	"./theMagicFlute/tmf-icon-M-round.png": "6f8d",
	"./theMagicFlute/tmf-icon-M-round.webp": "777e",
	"./theMagicFlute/tmf-icon-M-rounded.png": "1016",
	"./theMagicFlute/tmf-icon-M-rounded.webp": "3646",
	"./theMagicFlute/tmf-login-v2.png": "43e5",
	"./theMagicFlute/tmf-login-v2.webp": "8529",
	"./theMagicFlute/tmf-login.png": "b891",
	"./theMagicFlute/tmf-login.webp": "8ad3",
	"./theMagicFlute/tmf-logo.png": "331d",
	"./theMagicFlute/tmf-logo.webp": "8dd0",
	"./voucher.webp": "2a5b",
	"./worldOfMusic/AW.png": "de4b",
	"./worldOfMusic/astroWhackerLogo.png": "160e",
	"./worldOfMusic/role/SchoolAdmin.png": "b3bc",
	"./worldOfMusic/role/Student.png": "b0ac",
	"./worldOfMusic/role/Teacher.png": "faa8",
	"./worldOfMusic/worldOfMusic.png": "486b",
	"./worldOfMusic/worldOfMusicLogo.png": "51ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b89";